// extracted by mini-css-extract-plugin
export default {"root":"SomethingWrong_root__ic+Jq","label":"SomethingWrong_label__+kywc","description":"SomethingWrong_description__T4LNg","title":"SomethingWrong_title__EMcz3"};